// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3UHSX","header":"ReportDetails_header__1IwoG","title":"ReportDetails_title__3TU9p","left":"ReportDetails_left__2IBl2"};